import { fitMarketLabel, squareMarketLabel } from "../services/marketSquareLayout";
import { MARKET_PALETTE, marketLabelColor, marketLabelStroke } from "../services/mindshareMarket";

function SteamMarketMarks({ nodes, squareMode, zoom, selected, onHover, onSelect, width }) {
  const k = zoom?.k || 1;
  const geometry = node => squareMode
    ? { x: -node.side / 2, y: -node.side / 2, width: node.side, height: node.side }
    : { r: node.r };
  const Mark = squareMode ? "rect" : "circle";
  return <>
    {nodes.map(node => <g key={node.data.app_id} className="mm-node"
      data-app={node.data.app_id} transform={`translate(${node.x},${node.y})`}
      onMouseEnter={() => onHover(node)} onMouseLeave={() => onHover(null)}
      onClick={event => { event.stopPropagation(); onSelect(selected?.data.app_id === node.data.app_id ? null : node); }}
      style={{ cursor: "pointer" }}>
      <Mark {...geometry(node)} className={squareMode ? "mm-square-core mm-bubble-core" : "mm-bubble-core"}
        fill={node.data.color} stroke={MARKET_PALETTE.canvas} strokeWidth={.65} vectorEffect="non-scaling-stroke" />
      {selected?.data.app_id === node.data.app_id && <Mark {...geometry(node)} fill="none"
        stroke={MARKET_PALETTE.text} strokeWidth={2} vectorEffect="non-scaling-stroke" />}
    </g>)}
    <g className="mm-label-layer" pointerEvents="none">
      {nodes.map(node => {
        const label = squareMode ? squareMarketLabel(node.data.name, node.side, k)
          : node.r > 16 / Math.pow(k, 1.15) ? fitMarketLabel(node.data.name, node.r * 2 - 6 / k, 13 / Math.pow(k, .8), {
            minCharacters: node.r * k > 80 ? 34 : node.r * k > 44 ? 27 : 16,
          }) : null;
        if (!label) return null;
        const halfText = label.text.length * label.fontSize * .54 * k / 2 + 4;
        const screenX = (zoom?.x || 0) + node.x * k;
        const x = halfText * 2 < width
          ? (Math.max(halfText, Math.min(width - halfText, screenX)) - (zoom?.x || 0)) / k : node.x;
        return <g key={node.data.app_id} className="mm-node" data-app={node.data.app_id}>
          <text x={x} y={node.y} dy=".35em" textAnchor="middle" fontSize={label.fontSize}
            fill={label.overflows ? MARKET_PALETTE.text : marketLabelColor(node.data.color)}
            stroke={label.overflows ? MARKET_PALETTE.canvas : marketLabelStroke(node.data.color)}
            strokeWidth={(label.overflows ? 2.4 : .75) / k} strokeOpacity={label.overflows ? .82 : 1}>{label.text}</text>
        </g>;
      })}
    </g>
  </>;
}

export default memo(SteamMarketMarks);
import { memo } from "react";
